import request from '@/utils/request'

// 获取用户信息
export const getUserInfoApi = () => request({
  url: '/bd/user/userInfo',
  method: 'get'
})
// 修改用户信息
export const updateUserInfoApi = (data) => request({
  url: '/bd/user/updateUser',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 修改用户信息
export const updatePasswordApi = (data) => request({
  url: '/bd/user/updatePassword',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 上传
export const uploadApi = (data) => request({
  url: '/base/upload',
  method: 'post',
  data,
  headers: { 'Content-Type': 'multipart/form-data' }
})